import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { createSubscription, NewSubscriptionData } from '../../../services/subscriptionService';
import { getLawyersForSelection, LawyerSelectionData } from '../../../services/lawyerService'; // (1) استيراد
import SubscriptionForm from './SubscriptionForm';
import formStyles from '../trainees/TraineeForm.module.css';

// (2) هذا هو النوع الذي يستقبله النموذج الآن
type FormInputs = NewSubscriptionData;

const AddSubscriptionPage: React.FC = () => {
  const navigate = useNavigate();
  const [lawyers, setLawyers] = useState<LawyerSelectionData[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // (3) جلب قائمة المحامين عند تحميل الصفحة
  useEffect(() => {
    getLawyersForSelection()
      .then(setLawyers)
      .catch(() => toast.error('فشل في جلب قائمة المحامين.'))
      .finally(() => setIsLoading(false));
  }, []);

  // (4) دالة الإرسال تستقبل الآن البيانات كاملة من النموذج
  const handleSubmit = (data: FormInputs) => {
    setIsSubmitting(true);
    const promise = createSubscription(data);
    
    toast.promise(promise, {
      loading: 'جاري إنشاء الاشتراك...',
      success: () => {
        navigate('/admin/subscriptions/list');
        return 'تم إنشاء الاشتراك بنجاح!';
      },
      error: (err) => {
        setIsSubmitting(false);
        return err.response?.data?.message || 'فشل في إنشاء الاشتراك.';
      },
    });
  };

  if (isLoading) {
    return <div>جاري تحميل قائمة المحامين...</div>;
  }

  return (
    <div className={formStyles.pageContainer}>
      <div className={formStyles.formContainer}>
        <h2 className={formStyles.title}>إضافة اشتراك جديد</h2>
        <SubscriptionForm 
          onSubmit={handleSubmit} 
          isEditMode={false} 
          isSubmitting={isSubmitting}
          lawyers={lawyers} // (5) تمرير قائمة المحامين إلى النموذج
        />
      </div>
    </div>
  );
};

export default AddSubscriptionPage;
